<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [],
      userinfo: {},
      loading: false,
      binding: false,
      unbinding: false,
      portal: {
        bound: false,
        bind_status: "unbound",
        cloud_account_name: "",
      },
    };
  },
  computed: {
    statusTagType() {
      return this.portal.bound ? "success" : "info";
    },
    statusLabel() {
      if (this.portal.bound) {
        return this.$t("menuitems.clouds.cloudbind.bound");
      }
      return this.$t("menuitems.clouds.cloudbind.unbound");
    },
    accountDisplay() {
      if (this.portal.cloud_account_name) {
        return this.portal.cloud_account_name;
      }
      return this.$t("menuitems.clouds.cloudbind.account_unknown");
    },
  },
  mounted() {
    this.title = this.$t("menuitems.clouds.cloudbind.text");
    this.items = [
      { text: this.$t("menuitems.clouds.text"), href: "/" },
      { text: this.title, active: true },
    ];
    this.userinfo = JSON.parse(localStorage.getItem("user") || "{}");
    this.handleBindQuery();
    this.fetchStatus();
  },
  methods: {
    post(action, payload) {
      return this.$axios.post(
        this.apiuri,
        Object.assign({ action: action }, payload || {}),
        { headers: { Openid: this.userinfo.openid } }
      );
    },
    applyPortalData(data) {
      if (!data) return;
      this.portal = Object.assign({}, this.portal, data);
    },
    handleBindQuery() {
      const result = this.$route.query.bind;
      if (result === "success") {
        this.$message({
          message: this.$t("menuitems.clouds.cloudbind.bind_success"),
          type: "success",
        });
        this.$router.replace({ path: this.$route.path });
        this.fetchStatus();
      } else if (result === "fail") {
        this.$message.error(this.$t("menuitems.clouds.cloudbind.bind_fail"));
        this.$router.replace({ path: this.$route.path });
      }
    },
    fetchStatus() {
      var that = this;
      that.loading = true;
      that.post("syncbindportalstatus")
        .then(function (response) {
          if (response.data.status === 200 && response.data.data) {
            that.applyPortalData(response.data.data);
          }
        })
        .finally(function () {
          that.loading = false;
        });
    },
    startBind() {
      var that = this;
      if (that.portal.bound) return;
      that.binding = true;
      that.post("syncbindportalstart")
        .then(function (response) {
          var bindUrl =
            response.data.data &&
            (response.data.data.bind_url || response.data.data.authorize_url);
          if (response.data.status === 200 && bindUrl) {
            window.location.href = bindUrl;
            return;
          }
          that.$message.error(that.$t("menuitems.clouds.cloudbind.bind_fail"));
        })
        .catch(function () {
          that.$message.error(that.$t("menuitems.clouds.cloudbind.bind_fail"));
        })
        .finally(function () {
          that.binding = false;
        });
    },
    confirmUnbind() {
      var that = this;
      that.$confirm(
        that.$t("menuitems.clouds.cloudbind.unbind_confirm"),
        that.$t("menuitems.clouds.cloudbind.unbind_action"),
        {
          type: "warning",
          confirmButtonText: that.$t("menuitems.clouds.cloudbind.unbind_action"),
          cancelButtonText: that.$t("global.button.cancel"),
        }
      )
        .then(function () {
          that.doUnbind();
        })
        .catch(function () {});
    },
    doUnbind() {
      var that = this;
      that.unbinding = true;
      that.post("syncbindportalunbind")
        .then(function (response) {
          if (response.data.status === 200) {
            that.$message.success(
              that.$t("menuitems.clouds.cloudbind.unbind_success")
            );
            that.applyPortalData(response.data.data || { bound: false, cloud_account_name: "" });
            that.fetchStatus();
            return;
          }
          that.$message.error(that.$t("menuitems.clouds.cloudbind.unbind_fail"));
        })
        .catch(function () {
          that.$message.error(that.$t("menuitems.clouds.cloudbind.unbind_fail"));
        })
        .finally(function () {
          that.unbinding = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="cloud-bind-page" v-loading="loading">
      <el-card class="box-card">
        <div slot="header" class="cloud-bind-header">
          <span>
            <i class="el-icon-connection"></i>
            {{ $t("menuitems.clouds.cloudbind.title") }}
          </span>
          <el-tag :type="statusTagType" size="small">{{ statusLabel }}</el-tag>
        </div>

        <p class="cloud-bind-desc">
          {{ portal.bound ? $t("menuitems.clouds.cloudbind.bound_hint") : $t("menuitems.clouds.cloudbind.desc_simple") }}
        </p>

        <ul class="cloud-bind-features">
          <li><i class="el-icon-check"></i>{{ $t("menuitems.clouds.cloudbind.feature_profile") }}</li>
          <li><i class="el-icon-check"></i>{{ $t("menuitems.clouds.cloudbind.feature_wallet") }}</li>
          <li><i class="el-icon-check"></i>{{ $t("menuitems.clouds.cloudbind.feature_order") }}</li>
        </ul>

        <div v-if="portal.bound" class="cloud-bind-account">
          <span class="cloud-bind-account-label">{{ $t("menuitems.clouds.cloudbind.cloud_account_label") }}</span>
          <span class="cloud-bind-account-name">{{ accountDisplay }}</span>
        </div>

        <div class="cloud-bind-actions">
          <el-button
            v-if="!portal.bound"
            type="primary"
            icon="el-icon-link"
            :loading="binding"
            @click="startBind"
          >
            {{ $t("menuitems.clouds.cloudbind.bind_action") }}
          </el-button>
          <el-button
            v-if="portal.bound"
            type="danger"
            plain
            :loading="unbinding"
            @click="confirmUnbind"
          >
            {{ $t("menuitems.clouds.cloudbind.unbind_action") }}
          </el-button>
          <el-button icon="el-icon-refresh" @click="fetchStatus">{{ $t("menuitems.clouds.nfcreader.refresh") }}</el-button>
        </div>
      </el-card>
    </div>
  </Layout>
</template>

<style scoped>
.cloud-bind-page {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

.cloud-bind-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-weight: 500;
}

.cloud-bind-header i {
  margin-right: 6px;
}

.cloud-bind-desc {
  margin: 0 0 16px;
  color: #606266;
  line-height: 1.6;
}

.cloud-bind-features {
  list-style: none;
  margin: 0 0 20px;
  padding: 12px 16px;
  background: #f5f7fa;
  border-radius: 4px;
}

.cloud-bind-features li {
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.8;
  color: #303133;
}

.cloud-bind-features i {
  color: #67c23a;
}

.cloud-bind-account {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.cloud-bind-account-label {
  color: #909399;
  font-size: 13px;
}

.cloud-bind-account-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.cloud-bind-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
</style>
